import * as React from "react";
import { CloudAccountCreateForm } from "./form";

export const CloudAccountCreateInitializer: React.FC = () => {
  return <CloudAccountCreateForm />;
};
